export default "__VITE_ASSET___kOiCKtA__"